module.exports = __webpack_public_path__ + "assets/img/USDT.61b642c1.png";